module.exports = __webpack_public_path__ + "static/media/booking-screenshot.702ed640.png";